export default {
  grayTextBlock: {
    backgroundColor: '#f1f1f1',
  },
  primary: {
    color: '#5ABDD7',
    fontWeight: 600,
  },
};
